import { useContext } from 'react';

import VisitContext from './context';

const useVisit = () => useContext(VisitContext);

export default useVisit;
